import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Image from 'components/Image';
import iconStar from 'images/icon_star.svg';
import iconShield from 'images/icon_shield.svg';
import styles from './index.module.css';

const Rating = ({ value, reliability }) => {
  const number = [];
  let numOfFille = value;
  for (let i = 0; i < 5; i += 1) {
    if (numOfFille > 0) {
      number.push(1);
      numOfFille -= 1;
    } else {
      number.push(undefined);
    }
  }

  return number.map((i, k) => {
    return (
      <Image
        key={k}
        className={cn(styles.img, { [styles.grey]: !i })}
        src={reliability ? iconShield : iconStar}
        alt="iconRating"
      />
    );
  });
};

Rating.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  reliability: PropTypes.bool.isRequired,
};

Rating.defaultProps = {
  reliability: false,
};

export default Rating;
